export default __webpack_public_path__ + "static/media/holdingLeaves.9b6c5d57.jpg";